import {
  ArticleRef,
  ArticlesOrderOptions,
  ArticlesSortOptions,
} from 'helpCenter/types'
import { authorizedGet } from '.'

export type GetArticlesInCategoryProps = {
  categoryId: string
  params?: {
    sort?: ArticlesSortOptions
    order?: ArticlesOrderOptions
  }
}
export type GetArticlesInCollectionProps = {
  collectionId: string
}
export async function getArticlesInCategory({
  categoryId,
  params: { sort, order } = {},
}: GetArticlesInCategoryProps): Promise<ArticleRef[]> {
  try {
    const response = await authorizedGet({
      endpoint: `categories/${categoryId}/articles`,
      params: { sort, order },
    })
    const { items } = await response.json() //{ items, count, pages, page }
    return items as ArticleRef[]
  } catch (e) {
    throw e
  }
}

export async function getArticlesInCollection({
  collectionId,
}: GetArticlesInCollectionProps): Promise<ArticleRef[]> {
  try {
    const response = await authorizedGet({
      endpoint: `collections/${collectionId}/articles`,
    })
    const { items } = await response.json() // {items, count, pages, page}
    return items as ArticleRef[]
  } catch (e) {
    throw e
  }
}
